module.exports = __webpack_public_path__ + "files/1f3ff32a3ab1023bd9e17658f6335de8.png";